import { BASE_PATH, BASE_PATH_EXTENSION_ADMIN } from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION_ADMIN}/delivery-notes`

export async function searchDeliveryNotes() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/search`, config)
}

export async function addDeliveryNotes(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create`, props, config)
}
